import React from 'react';
import posthog from 'posthog-js';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Header.css';

interface HeaderProps {
  showNav?: boolean;
}

const Header: React.FC<HeaderProps> = ({ showNav = true }) => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    if (window.location.pathname === '/') {
      e.preventDefault();
      posthog.capture('nav_link_clicked', { target: id, location: 'header' });
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.header 
      className="header"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="header-content">
        <motion.div 
          className="logo" 
          onClick={scrollToTop}
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.2 }}
        >
          <Link
            to="/"
            onClick={() => {
              scrollToTop();
              posthog.capture('nav_link_clicked', { target: 'logo_home', location: 'header' });
            }}
          >
            <img src="/NewLogo.png" alt="ColorCache" />
          </Link>
        </motion.div>
        
        {showNav && (
          <nav className="desktop-nav">
            <Link to="/" onClick={() => { scrollToTop(); posthog.capture('nav_link_clicked', { target: 'home', location: 'header' }); }}>Home</Link>
            <a href="/#features" onClick={(e) => scrollToSection(e, 'features')}>Features</a>
            <a href="/#pricing" onClick={(e) => scrollToSection(e, 'pricing')}>Pricing</a>
            <Link to="/faq" onClick={() => posthog.capture('nav_link_clicked', { target: 'faq', location: 'header' })}>FAQ</Link>
          </nav>
        )}
      </div>
    </motion.header>
  );
};

export default Header; 